import { cleanTrackingUrl } from './urlHelpers.js';

$(function () {
    window.navigationClickAnalytics = window.navigationClickAnalytics ||
        function (event, type, category, action, label) {
            if (event && event.button === 2) return;
            var url = event && event.currentTarget && event.currentTarget.href ? cleanTrackingUrl(event.currentTarget.href) : '';
            var fullLabel = url ? label + ' | ' + url : label;
            dataLayer.push({
                event: 'navigationClick',
                eventCategory: category,
                eventAction: action,
                eventLabel: fullLabel
            });
            if (typeof ga === 'function') {
                // Legacy GA pipeline: send the plain label exactly as it did
                // pre-2026 (no URL appended) so historical menu-click reports
                // stay continuous. The URL/fullLabel lives only on the new
                // dataLayer event above.
                ga('send', type, category, action, label);
            }
        };
});